import dayjs from 'dayjs';
import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import { EventsTile } from 'components/events/EventsTile';
import { getDeviceLeafById } from 'modules/leaves';

import { ActivityState } from 'types/aspen/events';
import { AppLeaf } from 'types/common/leaf';

import styles from './gridView.module.scss';

interface EventsGridProps {
  events: Map<string, Array<ActivityState>>;
  leaves?: Record<string, AppLeaf>;
}

export const GridView = ({ events, leaves }: EventsGridProps) => (
  <Box className={styles.container}>
    {Array.from(events.entries()).map(([date, eventList]) => (
      <Stack key={date} spacing={2} className={styles.dateGroup}>
        <Typography variant="h3" className={styles.title}>
          {dayjs(date).format('MMM DD, YYYY')}
        </Typography>
        <Box className={styles.eventsGrid}>
          {eventList.map((event) => {
            const leaf = getDeviceLeafById(leaves || {}, event.deviceId);
            return <EventsTile key={event.id} event={event} leaf={leaf} />;
          })}
        </Box>
      </Stack>
    ))}
  </Box>
);
